document.addEventListener('DOMContentLoaded', function () {
    const swiperGallery = document.querySelector('.swiper-gallery');

    if (swiperGallery && typeof Swiper !== 'undefined') {
        new Swiper(swiperGallery, {
            effect: 'cards',
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            initialSlide: 2,
            cardsEffect: {
                rotate: true,
                perSlideRotate: 2,
                perSlideOffset: 8,
            },
        });
    }

    // Entrance Animation
    const observerOptions = {
        threshold: 0.2
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const cards = entry.target.querySelectorAll('.gallery-card');
                cards.forEach((card, index) => {
                    setTimeout(() => {
                        card.classList.add('reveal');
                    }, index * 150);
                });
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    const container = document.querySelector('.animated-card-container');
    if (container) {
        observer.observe(container);
    }
});
